/*
 * Copyright (c) 2022-2026 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */
import { z } from 'zod'

export const AccelByteGameService = z.object({
  environmentId: z.string(),
  namespaces: z.array(z.string()),
  productEntitlementId: z.string()
})

export interface AccelByteGameService extends z.TypeOf<typeof AccelByteGameService> {}
